<par-form-field [showErrors]="showError" [errorText]="errorText" [control]="control">
  <label [for]="meta.key" class="label">
    {{ meta.name }}{{ meta.validators?.required ? '*' : '' }}
  </label>
  <hrp-select
    #selectControl
    [id]="meta.key"
    [formControl]="control"
    [displayNameFn]="displayNameFn(meta.options)"
    (valueChange)="getValueChangeEvent({ meta, event: $event })"
  >
    @if (meta.options?.length > 10) {
      <hrp-select-searchbar />
    }
    @for (
      option of meta.options | search: selectControl.$search()?.$query() : ['key'];
      track option.value
    ) {
      <hrp-select-option
        [value]="option.value"
        [disabled]="meta.options[option.key]?.disabled"
        [hidden]="meta.options[option.key]?.hidden"
      >
        {{ option.key }}
      </hrp-select-option>
    }
  </hrp-select>
</par-form-field>
